import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AddApp = (props: SvgIconProps) => {
  return (
    <SvgIcon
      height='24'
      viewBox='0 0 24 24'
      width='24'
      {...props}
    >
      <path
        d='M13.5 14V11H10.5V9H13.5V6H15.5V9H18.5V11H15.5V14H13.5ZM2.5 22V6H6.5V2H22.5V18H18.5V22H2.5ZM8.5 16H20.5V4H8.5V16Z'
        fill={props.fill}
      />
    </SvgIcon>
  );
};

export default AddApp;
